import { render } from "./PinIconRed.vue?vue&type=template&id=8d492b24"
const script = {}
script.render = render

export default script